/**
 * @module: 职位相关store
 * @author: Teacher Tang
 * @date: 2019-11-16 14:31:37
 */
import { observable, action } from "mobx";
import axios from "axios";
import ywk from "@clouderwork/ywk";
import { withRole } from "@src/utils/residentNew";

class Offer {
  // 用于cancel ajax请求
  @observable source;
  // 职位列表
  @observable jobList: any[] = [];
  // 职位列表数据总数
  @observable total: number = 0;
  // 职位列表查询条件
  @observable jobListQuery: any = {};
  // 首次加载
  @observable loading: boolean = true;
  // 加载更多
  @observable refreshing: boolean = false;

  // 设置值
  @action.bound
  setProperyVal(key: string, val: any) {
    this[key] = val;
  }

  /** 获取职位列表数据 */
  @action.bound
  async getJobList(query: any, isPullOrPush = false) {
    if (query.pagenum === 1 && !isPullOrPush) {
      this.loading = true;
    } else {
      this.refreshing = true;
    }
    if(isPullOrPush) {
      this.refreshing = true;
    }
    // 阻止上一个请求
    if (this.source) {
      this.source.cancel();
    }
    this.source = axios.CancelToken.source();
    const data = await axios.get("/zhaopin/api/company/offers", {
      params: withRole(query),
      cancelToken: this.source.token
    })
    const res = data.data
    if (res.error_code === 0 && res.offers) {
      const { total, offers } = res.offers;
      if (total > 0) {
        if (query.pagenum === 1) {
          this.jobList = offers;
        } else {
          this.jobList = this.jobList.concat(offers);
        }
      } else {
        this.jobList = [];
      }
      this.jobListQuery = query;
      this.total = total;
    }
    this.loading = false;
    setTimeout(() => {
      this.refreshing = false;
    }, 100);
  }
}

export default Offer;
